import { useNavigate } from "@tanstack/react-router";
import { FileQuestion, Home, ArrowLeft } from "lucide-react";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        @keyframes fadeSlideUp {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .btn-action {
          transition: opacity 0.15s ease, transform 0.15s ease, background-color 0.15s ease;
        }
        .btn-action:hover {
          transform: translateY(-1px);
        }
        .btn-action:active {
          transform: translateY(0);
        }
        .btn-back:hover {
          background: var(--login-border);
        }
        .btn-home:hover {
          opacity: 0.9;
        }
      `}</style>

      {/* This wrapper expands to fill the entire available height of the AppShell's <main> tag.
        We remove all borders and surface backgrounds so it seamlessly blends into the current theme.
      */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          /* Accounts for desktop topbar (3.5rem) and mobile bottom nav (4rem) safely */
          minHeight: "calc(100vh - 8rem)",
          padding: "2rem",
          boxSizing: "border-box",
          textAlign: "center",
          animation: "fadeSlideUp 0.3s ease both",
        }}
      >
        <div
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            background: "var(--login-border)", // Uses a subtle theme-aware background instead of surface
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "1.5rem",
          }}
        >
          <FileQuestion
            size={36}
            strokeWidth={1.5}
            color="var(--login-accent)"
          />
        </div>

        <h1
          style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontWeight: 700,
            textTransform: "uppercase",
            fontSize: "2rem",
            letterSpacing: "0.04em",
            color: "var(--login-text)",
            margin: "0 0 0.5rem 0",
          }}
        >
          Página não encontrada
        </h1>

        <p
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: "1rem",
            color: "var(--login-muted)",
            margin: "0 0 2rem 0",
            maxWidth: "320px",
            lineHeight: 1.5,
          }}
        >
          O endereço que você tentou acessar não existe ou foi movido.
        </p>

        <div
          style={{
            display: "flex",
            gap: "0.75rem",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <button
            className="btn-action btn-back"
            onClick={() => window.history.back()}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              padding: "0.75rem 1.25rem",
              background: "transparent",
              border: "1px solid var(--login-border)",
              borderRadius: "0.5rem",
              color: "var(--login-text)",
              fontFamily: "'Barlow Condensed', sans-serif",
              fontWeight: 600,
              textTransform: "uppercase",
              fontSize: "0.9375rem",
              letterSpacing: "0.05em",
              cursor: "pointer",
            }}
          >
            <ArrowLeft size={18} />
            Voltar
          </button>

          <button
            className="btn-action btn-home"
            onClick={() => navigate({ to: "/" })}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              padding: "0.75rem 1.25rem",
              background: "var(--login-accent)",
              border: "none",
              borderRadius: "0.5rem",
              color: "#fff",
              fontFamily: "'Barlow Condensed', sans-serif",
              fontWeight: 600,
              textTransform: "uppercase",
              fontSize: "0.9375rem",
              letterSpacing: "0.05em",
              cursor: "pointer",
            }}
          >
            <Home size={18} />
            Ir para o Início
          </button>
        </div>
      </div>
    </>
  );
}
